import React from 'react';
import '../styles/RouteInfoBox.css';
import { FaClock, FaRoute, FaFlagCheckered } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const RouteInfoBox = ({ route, stops, onStartClick, onSaveClick }) => {
  const { t } = useTranslation();

  if (!route) {
    return null;
  }

  return (
    <div className="route-info-box">
      <div className="route-stats">
        <div className="info-item">
          <FaFlagCheckered className="info-icon" />
          <span className="info-label">{stops} {t('route_info.stops')}</span>
        </div>
        <div className="info-item">
          <FaClock className="info-icon" />
          <span className="info-label">{route.static_duration_text}</span>
        </div>
        <div className="info-item">
          <FaRoute className="info-icon" />
          <span className="info-label">{route.distance_text}</span>
        </div>
      </div>
      <div className="route-actions">
        <button className="route-btn-start" onClick={onStartClick}>{t('route_info.start')}</button>
        <button className="route-btn-save" onClick={onSaveClick}>{t('route_info.save')}</button>
      </div>
    </div>
  );
};

export default RouteInfoBox;
